<template>
<div>
    <h2><a class="is-size-6 has-text-weight-bold has-text-underline is-white-space-nowrap" @click="openPageHelp=true">Page Help</a></h2>
    <div :style="{width: width, height: height}" class="model" :class="{'show-modal': imgLoaded}" v-if="openPageHelp">
        <div class="model-head">
            <a class="model-close" v-on:click="openPageHelp=false"><img src="/img/close.png" /></a>
        </div>
        <div class="model-body center">
            <div class="is-flex is-justify-content-center w-100">
                <img @load="onImgLoad" :src="imageDescription" :alt="imageAlt">
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        pageHelp:String,
        width: String,
        height: String,
    },
    computed: {
        imageDescription() {
            switch (this.pageHelp) {
                case 'filters':
                    return '/img/HELP_filters.png';
                case 'referral':
                    return '/img/HELP_referral.png';
                case 'results':
                    return '/img/HELP_results.png';
                case 'detailed':
                    return '/img/HELP_detailedview.png';
                case 'compare':
                    return '/img/HELP_comparison.png';
                case 'shortlist':
                    return '/img/HELP_shortlist.png';
                case 'watchlist':
                    return '/img/HELP_watchlist.png';
                case 'dashboard':
                    return '/img/HELP_dashboard.png';
                default:
                    break;
            }
            return '';
        },
        imageAlt() {
            switch (this.pageHelp) {
                case 'referral':
                    return 'Check on which investment platforms the various share classes of your fund can be bought';
                case 'results':
                    return 'Once your search results are displayed, sort your investment funds and use filters to trim the list of funds to choose from';
                case 'compare':
                    return 'Compare your investment fund to its category peers. Select 1 criteria out of 5 and see your fund rankings plus the top funds ';
                default:
                    break;
            }
            return '';
        }
    },
    data() {
        return {
            openPageHelp: false,
            imgLoaded: false
        }
    },
    name: 'PageHelp',
     methods: {
         onImgLoad () {
             this.imgLoaded = true
         }
     },
}
</script>

<style scoped>
.model{
    background-color:#FFF;
    position: fixed;
    top:45px;
    max-width: 1000px;
    z-index:300;
    color:#333;
    -webkit-box-shadow: 5px 5px 50px 1px #4F4F4F;
    box-shadow: 5px 5px 50px 1px #4F4F4F;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: 45px auto 0;
    display: none;
    overflow: auto;
    max-height: calc(100vh - 90px);
    height: auto;
}
.show-modal {
    display: block!important;;
}

.model-icon{
    background-color:#ccc;
    padding:10px;
}

.model-head .model-close img{
    height:50px;
    float:right;
}
.model-body{
    padding: 0 25px 25px 25px;
    display: flex;
    justify-content: center;
    width: 100%;
}
.model-body h2{
    font-weight:900;
    margin-bottom:20px;
}

.model-body ul {
    list-style: square;
    padding-left: 15px;
}

.model-body ul li {
    margin-bottom: 15px;
}
</style>